import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { fetchSentMessage, clearSelectedMessage } from 'message/actions/message-details.actions';
import { deleteSentMessage } from 'message/actions/sent.actions';
import { checkAccess } from 'app/actions/app.actions';
import tabs from '../messages-tab/tabs';
import template from './sent-message-details.html';

const mapStateToThis = ({ messages, session, config }) => {
  const { locale, emailAddress } = session;
  const { SENT } = tabs;
  const { selectedMessage } = messages;
  const { recipientCategoryCode } = selectedMessage;
  const { recipientCategories } = config;
  let recipientCategory = recipientCategories.find((category) => category.categoryCode === recipientCategoryCode);
  recipientCategory = recipientCategory ? recipientCategory.translations[locale] : '';

  return {
    emailAddress,
    SENT,
    selectedMessage,
    recipientCategory,
  };
};

const mapDispatchToThis = {
  fetchSentMessage,
  clearSelectedMessage,
  deleteSentMessage,
  setActiveTab,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$sce', '$state', '$ngRedux', 'Notifications', 'messageDefinitionService')
class SentMessageDetailsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await this.fetchSentMessage(this.sentMessageId);
    this.canDelete = this.selectedMessage.authorName === this.emailAddress;
  }

  $onDestroy() {
    this.clearSelectedMessage();
    this.unsubscribe();
  }

  showRecipientsList() {
    this.Notifications.showComplexDialog({
      component: 'recipientsList',
      resolve: {
        sentMessageId: () => this.sentMessageId,
        allowReply: () => this.selectedMessage.allowReply,
      },
    });
  }

  async onDeleteMessage() {
    await this.deleteSentMessage(this.sentMessageId);
    this.Notifications.alertSuccess(this.messageDefinitionService.get('MSG_DELETE', 'desc'));
    this.goToSentMessages();
  }

  goToSentMessages() {
    this.setActiveTab(this.SENT, 'activeTab');
    this.$state.go('message.list');
  }
}

export default class SentMessageDetailsComponent {
  constructor() {
    this.controller = SentMessageDetailsController;
    this.template = template;
    this.bindings = {
      sentMessageId: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/sent-message-details/sent-message-details-component.js